import React from "react";
import { TabSelector } from "@/components/TabSelector";

export type AssetClass = "crypto" | "stocks";

interface AssetClassToggleProps {
  value: AssetClass;
  onChange: (value: AssetClass) => void;
  className?: string;
  variant?: "default" | "lg";
}

export const AssetClassToggle: React.FC<AssetClassToggleProps> = ({
  value,
  onChange,
  className,
  variant = "default",
}) => {
  return (
    <TabSelector
      options={[
        { value: "crypto", label: "Crypto" },
        { value: "stocks", label: "Stocks" },
      ]}
      value={value}
      onChange={onChange}
      className={className}
      variant={variant}
    />
  );
};
